export var TEMPLATE_UID = 'mEzKnY';
export var TEMPLATE_ID = 'mEzKnY';
export var TEMPLATE_URL_PARAMS = '?force_demo=true&section=create';
export var CTA_LABEL = 'Start with this typeform';